import { render } from "./ForgotPassword.vue?vue&type=template&id=5d71acee&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "@/assets/styles/auth.css?vue&type=style&index=0&id=5d71acee&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d71acee"]])

export default __exports__